import Analytics from '../../components/analytics/Analytics';

export default function AnalyticsPage() {
  return <Analytics />;
}
